export default {
    heading: 'Hi John,',
    description: 'You have not uploaded your financial information for a long time. Do you want to update it ?',
    remindText: 'Remind Me Later',
    updateText: 'Update Now',
};
